export default {
  EPBM_REGULAR: 'regular',
  EPBM_FREESPINS: 'freespins',
}
